import { Trans } from '@lingui/macro';

interface ScaleReconnectionProps {
  showEscalationMessage: boolean;
  officePhoneNumber?: string;
}

const ScaleReconnection = ({ showEscalationMessage, officePhoneNumber }: ScaleReconnectionProps) =>
  <div className="d-flex flex-column align-items-center justify-content-center min-vh-50">
    {
      showEscalationMessage &&
      <div className={`alert alert-danger border text-center mt-2 mb-3 px-0 py-4 w-100`}>
        <span><Trans>Unable to connect, contact the office</Trans></span>
        {officePhoneNumber && <div>{officePhoneNumber}</div>}
      </div>
    }
    <div className="mb-4">
      <h3 className="text-center mb-4">
        <Trans>We're reconnecting to the scale</Trans>
      </h3>
    </div>
    <div className="mb-4">
      <div
        className="spinner-border text-primary"
        style={{ width: '8rem', borderWidth: ".50rem", height: '8rem' }}
        role="status" />
    </div>
    <div className="alert alert-light border text-center my-3 w-100">
      <span className="text-muted">
        <Trans>Please wait until the weight display is accurate before accepting.</Trans>
      </span>
    </div>
  </div>;

export default ScaleReconnection;